import useEventParticipant from './use-event-participant';

export default useEventParticipant;
